"use client"

import { useEffect } from "react"
import { useQuery } from "@tanstack/react-query"
import { useSearchParams } from "next/navigation"

import { ItemNotFound } from "@/components/molecules/NotFound"
import { PaginationContainer } from "@/components/organisms/PaginationContainer/pagination-container"
import { getPostsAction } from "@/app/actions/post/post.action"
import EventList from "./event-list"
import { ReactQueryProvider } from "@/app/contexts/QueryProvider"

const Stories = () => {
  const searchParams = useSearchParams()
  const queryParams = Object.fromEntries(searchParams.entries())
  const currentPage = parseInt(searchParams.get("page") || "1", 10) 

  const {
    data,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["stories", { page: currentPage }],
    queryFn: async () => {
      const { data } = await getPostsAction(currentPage)
      return data as any
    },
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    retry: 2,
  })

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }, [currentPage])

  if (isLoading) {
    return (
      <div className="mx-auto max-w-screen-2xl py-16">
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {[...Array(3)].map((_, i) => (
             <div
              key={i}
              className="h-80 w-full animate-pulse rounded-xl bg-muted"
            />
          ))}
        </div>
      </div>
    )
  }

  if (data?.data?.items?.length === 0 || isError || !data?.data?.items) {
    return <ItemNotFound />
  }

  const posts = data?.data?.items || []
  const totalPages = data?.data?.totalPages || 0

  return (
        <div className="mx-auto max-w-screen-2xl py-16 dark:bg-gray-900">
          <div className="flex flex-col justify-self-center duration-500">
            <EventList data={posts} />
            {totalPages > 1 && (
              <div className="mt-6">
                <PaginationContainer
                  queryParams={queryParams}
                  totalPages={totalPages}
                />
              </div>  
            )}
          </div>
        </div>
  )
}

export const Posts = () => {
  return (
    <ReactQueryProvider>
      <Stories />
    </ReactQueryProvider>
  )
}